// extracted by mini-css-extract-plugin
export default {"truncate":"VideoGrid_truncate__5X0J7","shadow":"VideoGrid_shadow__+Hgyn"};